import React from 'react';
import { PaymentHistory } from './PaymentHistory';
import { usePermissions } from '@/hooks/usePermissions';

export function FinancialInsights() {
  const { canMarkAsPaid } = usePermissions();

  return (
    <div className="flex flex-1 flex-col gap-6 p-4 lg:p-6 overflow-auto">
      <div>
        <h2 className="text-2xl font-semibold tracking-tight">Payment History</h2>
        <p className="text-sm text-muted-foreground mt-1">
          View historical payment records and distributions
        </p>
      </div>

      <PaymentHistory isAdmin={canMarkAsPaid} />
    </div>
  );
}
